__turbopack_context__.v({
  "airlineIcon": "F8RKLa_airlineIcon",
  "airlineWrapper": "F8RKLa_airlineWrapper",
  "cardContent": "F8RKLa_cardContent",
  "featuresWrapper": "F8RKLa_featuresWrapper",
  "icon": "F8RKLa_icon",
  "infoBlock": "F8RKLa_infoBlock",
  "infoItem": "F8RKLa_infoItem",
  "listItemContent": "F8RKLa_listItemContent",
  "listItemRoot": "F8RKLa_listItemRoot" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "listItemRootSelected": "F8RKLa_listItemRootSelected",
  "priceWrapper": "F8RKLa_priceWrapper",
  "priceWrapperSelected": "F8RKLa_priceWrapperSelected",
  "remark": "F8RKLa_remark",
});
